import BenchlingConfig from 'BenchlingConfig';
import EntityStore from 'stores/EntityStore';

export function isMonomerManagementEnabledForUser(): boolean {
  const currentUser = EntityStore.currentUser();
  return currentUser?.isTenantAdmin && BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES;
}
